export default {
  /**
   * @description 数组对象求和
   * @example ([{a:1},{a:2},{a:3}], 'a') => 6
   * @param {Object Array} objArr 必传 目标对象数组
   * @param {*} key 必传 查询的属性名
   * @returns
   */
  objArr_sum: (objArr, key) => objArr.reduce((prev, cur) => prev + cur[key], 0),
  /**
   * @description 通过对比相同属性值 删除对象数组
   * @example ([{a:1},{a:2},{a:3}], 'a', 1) => [{a:2},{a:3}]
   * @param {Object Array} objArr 必传 目标对象数组
   * @param {String} key 必传 查询的属性名
   * @param {Number|Boolean|String} value 必传 删除的属性值
   * @returns {Object Array}
   */
  objArr_delete_item_by_attrValue: (objArr, key, value) =>
    objArr.filter(x => x[key] !== value),
  /**
   * @description 通过对比属性的"唯一值" 返回对象数组中的对应项 无则返回空或空数组
   * @example ([{a:1},{a:2},{a:3}], 'a', 1) => {a:1}
   * @example ([{a:1},{a:2},{a:3}], 'a', [1,2]) => [{a:1},{a:2}]
   * @example ([{a:1,b:11},{a:2,b:22},{a:3,b:33}], 'a', 1, 'b') => 11
   * @example ([{a:1,b:11},{a:2,b:22},{a:3,b:33}], 'a', [1,2], 'b') => [11,22]
   * @param {Object Array} objArr 必传 目标对象数组
   * @param {String} key 必传 查询的属性名
   * @param {Number|Boolean|String|Array} value 必传 查询的值
   * @param {String} targetkey 非必传 需要返回的对象属性 不传 即返回该对象
   */
  objArr_query_item_by_only_attrValue: (objArr, key, value, targetkey = '') => {
    if (typeof value !== 'object') {
      let resultItem = objArr.find(x => x[key] === value)
      return resultItem ? (targetkey ? resultItem[targetkey] : resultItem) : ''
    } else {
      let resultArr = []
      value.forEach(item => {
        let resultItem = objArr.find(x => x[key] === item)
        resultItem
          ? resultArr.push(targetkey ? resultItem[targetkey] : resultItem)
          : ''
      })
      return resultArr
    }
  },
  /**
   * @description 对象数组按照另一个数组排序
   * @example ([{a:1},{a:2},{a:3}], [1,3,2]) => [{a:1},{a:3},{a:2}]
   * @param {Object Array} objArr 必传 目标对象数组
   * @param {Array} arr 必传 参考对象数组
   */
  objArr_sort_by_array: (objArr, arr) => {
    objArr.sort((prev, next) => {
      return arr.indexOf(prev.age) - arr.indexOf(next.age)
    })
  },
}
